<ub-card [rounded]="true">
  <h3 title><span class="t-upper t-weight--normal">{{ title }}</span> {{ subtitle }}</h3>
  <div content>
    @if ($loaded()) {
      <fixed-data-table [table]="table" [defaultColumns]="defaultColumns" [options]="options"></fixed-data-table>
    }
  </div>
  <div footer>
    <a *ngIf="cardUserUsername() === 'profile'" mat-flat-button color="primary" [routerLink]="['/bookings/available']" i18n>View all</a>
    <a *ngIf="cardUserUsername() !== 'profile'" mat-flat-button color="primary" [routerLink]="['/', 'users', cardUserUsername(), 'available']" i18n>View all</a>
  </div>
</ub-card>
